import { render, staticRenderFns } from "./ArchivedCatalogs.vue?vue&type=template&id=acc71978&scoped=true"
import script from "./ArchivedCatalogs.vue?vue&type=script&lang=js"
export * from "./ArchivedCatalogs.vue?vue&type=script&lang=js"
import style0 from "./ArchivedCatalogs.vue?vue&type=style&index=0&id=acc71978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc71978",
  null
  
)

export default component.exports